import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Cold-wedge instrumentation (see the boot watchdog in App.js). On the residual
// cold-init wedge the client gets stuck BEFORE it issues the DATA request, so no
// /rest/v1/ request ever dispatches - even though the AUTH token refresh
// (/auth/v1/) often DOES dispatch on a stale-token cold load. So we track DATA
// (REST) dispatch SPECIFICALLY, not "any fetch": the auth refresh can no longer
// mask a data wedge (the bug where the watchdog stood down). A slow network still
// dispatches its data request fast (only the response lags), so it flips this flag
// and is never mistaken for a wedge. Clear the one-shot reload cap only on a
// successful DATA response (= the data path is actually healthy). Attached ONLY to
// the Supabase client; app/CSV/photo fetches use window.fetch and never set this.
let _sbDataFetchFired = false
export function supabaseDataFetchHasFired() { return _sbDataFetchFired }
const instrumentedFetch = (input, init) => {
  const url = typeof input === 'string' ? input : (input && input.url) || ''
  const isData = url.includes('/rest/v1/')
  if (isData) _sbDataFetchFired = true
  return fetch(input, init).then((res) => {
    if (isData && res && res.ok) { try { sessionStorage.removeItem('kyg_cold_reload') } catch {} }
    return res
  })
}

// No custom `lock`. supabase-js 2.107+ dropped the navigator.locks mutex (which
// deadlocked across the Google OAuth redirect and broke SSO) for a lockless,
// SSO-safe commit-guard. Passing ANY custom lock opts back into the deadlock-prone
// legacy path, so we omit it and stay on the modern lockless default.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
  global: { fetch: instrumentedFetch },
})
